import React, { Component } from 'react';
import { Link, Redirect } from 'react-router-dom';
import { getProducts, saveProduct } from '../services/productService';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import * as userService from '../services/userService';
import Joi from 'joi-browser';
import auth from '../services/authService';
import CheckoutForm from './checkoutForm';
import CheckoutPaymentOption from './checkoutPaymentOption';
import Loader from './loader';
import keys from '../dev.js';

const stripePromise = loadStripe(keys.publishableKey);

class CheckoutLeftBlock extends Component {
  state = {
    movingToPay: false,
    loading: true,
    userInfo: '',
    data: {
      profilePic: '',
      email: '',
      password: '',
      name: '',
      phone: '',
      address: '',
      city: '',
      country: '',
      postalCode: '',

      //   theme: '',
    },
    errors: {},
  };

  schema = {
    _id: Joi.string(),
    profilePic: Joi.string(),
    email: Joi.string().required().email().label('Username'),
    password: Joi.string().required().min(5).label('Password'),
    name: Joi.string().required().label('Name'),
    phone: Joi.string().label('Phone Number'),
    address: Joi.string().label('Address'),
    city: Joi.string().label('City'),
    country: Joi.string().label('Country'),
    postalCode: Joi.string().label('Postal code'),
  };

  async componentDidMount() {
    window.scrollTo(0, 0);

    const user = auth.getCurrentUser();
    const id = user._id;

    const { data: products } = await getProducts();

    const { data: res } = await userService.getMyDetails(id);
    this.setState({
      data: this.mapToViewModel(res),
      imagePreviewUrl: res.profilePic,
      products,
      loading: false,
    });
  }

  mapToViewModel(user) {
    return {
      _id: user._id,
      name: user.name,
      email: user.email,
      phone: user.phone || '',
      password: user.password,
      profilePic: user.profilePic || '',
      address: user.address || '',
      city: user.city || '',
      country: user.country || 'Pakistan',
      postalCode: user.postalCode || '',
      //   theme: user.theme,
    };
  }

  validate = () => {
    const options = { abortEarly: false };
    const { error } = Joi.validate(this.state.data, this.schema, options);
    if (!error) return null;

    const errors = {};
    for (let item of error.details) errors[item.path[0]] = item.message;
    return errors;
  };

  validateProperty = ({ name, value }) => {
    const obj = { [name]: value };
    const schema = { [name]: this.schema[name] };
    const { error } = Joi.validate(obj, schema);
    return error ? error.details[0].message : null;
  };

  handleChange = ({ currentTarget: input }) => {
    const errors = { ...this.state.errors };
    const errorMessage = this.validateProperty(input);
    if (errorMessage) errors[input.name] = errorMessage;
    else delete errors[input.name];

    const data = { ...this.state.data };
    data[input.name] = input.value;

    this.setState({ data, errors });
  };

  handleSubmit = (e) => {
    e.preventDefault();
    const errors = this.validate();
    this.setState({ errors: errors || {} });
    if (errors) return;

    this.doSubmit();
  };

  doSubmit = async () => {
    try {
      this.setState({ movingToPay: true });
      const { data } = this.state;

      const response = await userService.updateUser(data);

      this.setState({ userInfo: data });
      auth.logout();
      auth.loginWithJwt(response.headers['x-auth-token']);

      // this.props.handleNotification({
      //   message: 'Order placed successfully!',
      //   img: '/img/success.png',
      // });

      // this.props.updateUser();
      //   this.props.history.push('/profile/');
      // window.location = '/';
    } catch (ex) {
      if (ex.response && ex.response.status === 400) {
        const errors = { ...this.state.errors };
        errors.email = ex.response.data;
        this.setState({ errors });
      }
    }
  };

  changeInfo = () => {
    this.setState({ userInfo: '', movingToPay: false });
  };

  completeOrder = async () => {
    const { data, products } = this.state;
    const { cartItems } = this.props;

    try {
      let errorsInCart = false;
      let moveToPayment = false;

      for (const item of cartItems) {
        let realProduct = products.filter((p) => p._id === item.product._id);

        if (realProduct[0].inStock >= item.quantity) {
          // realProduct[0].inStock -= item.quantity;
          // const res = await saveProduct(realProduct[0]);
          // console.log(res);
        } else {
          errorsInCart = true;
          const index = cartItems.indexOf(item);

          if (realProduct[0].inStock === 0) {
            cartItems[index].product.error = 'This product have sold out.';
          } else if (realProduct[0].inStock < item.quantity) {
            cartItems[index].product.error =
              'Only ' + realProduct[0].inStock + ' items left.';
          }

          cartItems[index].product.inStock = realProduct[0].inStock;
          this.props.handleAddtoCart(cartItems[index].product, 0);
        }
      }

      if (!errorsInCart)
        for (const item of cartItems) {
          let realProduct = products.filter((p) => p._id === item.product._id);

          if (realProduct[0].inStock >= item.quantity) {
            realProduct[0].inStock -= item.quantity;
            await saveProduct(realProduct[0]);
          }
          moveToPayment = true;
        }

      if (moveToPayment) {
        try {
          data.userId = data._id;
          data.orderStatus = 'Placed';
          data.useremail = data.email;
          delete data._id;
          delete data.password;
          delete data.email;

          let order = { ...data, cartItems: [...cartItems] };
          order.total = this.calculateTotal(order.cartItems);
          return order;

          // const res = await saveOrder(order);

          // this.props.handleNotification({
          //   message: 'Order placed successfully!',
          //   img: '/img/success.png',
          // });

          // this.props.emptyCart();
          // this.props.history.push('/dashboard/orders/order/' + res.data._id);
        } catch (err) {
          console.log(err);
        }
      }
    } catch (err) {
      console.log(err);
    }
  };

  render() {
    const { userInfo, data, errors, loading, movingToPay } = this.state;

    if (!auth.getCurrentUser()) return <Redirect to='/login/' />;

    if (auth.getCurrentUser().isAdmin)
      return (
        <div className='not-found col-md-7'>
          <h1>Admin can't place order</h1>
          <p>Login with customer's account.</p>
          <Link to='/logout/'>
            <button className='explore-categories'>Logout</button>
          </Link>
        </div>
      );

    if (loading) return <Loader />;

    return (
      <div className='checkout-left col-md-7'>
        {!userInfo && (
          <CheckoutForm
            movingToPay={movingToPay}
            data={data}
            errors={errors}
            handleChange={this.handleChange}
            handleSubmit={this.handleSubmit}
          />
        )}

        {userInfo && (
          <Elements stripe={stripePromise}>
            <CheckoutPaymentOption
              props={this.props}
              data={data}
              completeOrder={this.completeOrder}
              changeInfo={this.changeInfo}
              handleNotification={this.props.handleNotification}
              emptyCart={this.props.emptyCart}
            />
          </Elements>
        )}
      </div>
    );
  }

  calculateTotal = (cartItems) => {
    let total = 0;

    for (const c of cartItems) total = total + c.product.price * c.quantity;

    return total;
  };
}

export default CheckoutLeftBlock;
